module.exports = __webpack_public_path__ + "img/botellas.1cccc708.png";